import { configureStore } from '@reduxjs/toolkit';

// import patternReducer from './patternSlice';
import registrationReducer from './registrationSlice';
import privacyReducer from './privacySlice';
import sharingReducer from './sharingSlice';
import keysReducer from './keysSlice';
import challengeReducer from './challengeSlice';

// Automatically adds the thunk middleware and the Redux DevTools extension
export const store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    // pattern: patternReducer,
    registration: registrationReducer,
    privacy: privacyReducer,
    sharing: sharingReducer,
    keys: keysReducer,
    challenge: challengeReducer,
  }
});